import styled from 'styled-components';

type AvatarWrapperProps = {
  circle: boolean;
};

export const AvatarWrapper = styled('div')<AvatarWrapperProps>`
  align-items: center;
  background-color: #34c8b6;
  border-radius: ${(props) => (props.circle ? '50%' : '1rem')};
  box-sizing: border-box;
  color: var(--exact-white);
  display: inline-flex;
  font-size: 12px;
  font-variant: tabular-nums;
  height: 28px;
  justify-content: center;
  list-style: none;
  margin: 0;
  overflow: hidden;
  padding: 0;
  position: relative;
  text-align: center;
  vertical-align: middle;
  white-space: nowrap;
  width: 28px;
`;
